// extracted by mini-css-extract-plugin
export default {"_list":"Financial__list__QZiz5","_inputfix":"Financial__inputfix__wesyf"};